import { ComponentType } from 'react';
import { Feature } from '../feature.model';
import { AnyAction, Middleware, Reducer } from '@reduxjs/toolkit';
import { Epic } from 'redux-observable';
export function createFeature<
  TComponents extends Record<string, ComponentType<any>>,
  THooks,
  TReducerMap extends Record<string, Reducer<any, AnyAction>>,
  TMiddlewares extends Middleware[],
  TEpics extends Epic[]
>(
  feature: Feature<TComponents, THooks, TReducerMap, TMiddlewares, TEpics>
): Feature<TComponents, THooks, TReducerMap, TMiddlewares, TEpics> {
  return feature;
}
